import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

import SearchId from './SearchId.js';
import SearchPassword from './SearchPassword.js';

import IdentifierPageLogoPath from '../../../image/SearchIdentifierLogo.png';

const SearchView = () => {
  const history = useHistory();

  return (
    <TopLevelWrapper>
      <TitleWrapper onClick={() => history.push('/')}>
        <Logo src={IdentifierPageLogoPath}/>
        <Title>LINKO ZONE</Title>
      </TitleWrapper>
      <InfoBoxWrapper>
        <SearchId/>
        <SearchPassword/>
      </InfoBoxWrapper>
    </TopLevelWrapper>
  );
}

export default SearchView;

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;

  align-items: center;

  width: 345px;

  &:hover {
    cursor: pointer;
  }
`;

const Logo = styled.img`
  width: 78px;
  height: 78px;

  margin-right: 15px;
`;

const Title = styled.p`
  font-family: NotoSansKR-Bold;
  font-size: 35px;

  color: #FF8B48;

  margin: 0 0 0 0;
`;

const InfoBoxWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: flex-start;

  margin-top: 40px;

  gap: 41px;
`;
